<div class="success-dialog-wrapper">
    <!-- Close Button -->
    <button class="btn-close-dialog" (click)="close()">
        <i class="bi bi-x"></i>
    </button>

    <!-- Header with Confetti & Icon -->
    <div class="success-header">
      

        <div class="icon-outer-circle">
            <div class="icon-inner-circle">
                <i class="bi bi-box-arrow-right" style="-webkit-text-stroke: 1px;border: none;color:#EF4444 " (click)="close()"></i>
            </div>
        </div>
    </div>

    <!-- Body -->
    <div class="dialog-body">
        <h2 class="dialog-title">{{ data.title || 'Success!' }}</h2>
        <p class="dialog-subtitle">{{ data.subtitle }}</p>
    </div>

    <!-- Action -->
    <div class="dialog-action d-flex flex-column flex-md-row gap-3 mt-4 justify-content-center">
         <button class="btn btn-cancel w-100 w-md-25" (click)="close()">Cancel</button>
        <button class="btn btn-continue w-100 w-md-25" (click)="logout()">Logout</button>
    </div>
</div>